import { borderRadius, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const LogoBadge = styled.div`
  position: absolute;
  right: -4px;
  bottom: -4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 2px;
  border-radius: ${borderRadius.rFull};
  background-color: var(--background-soft);
`;

export const SecondaryText = styled.div`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TrackingStatus = styled.span<{ $isTracking: boolean }>`
  color: ${({ $isTracking }) =>
    $isTracking ? 'var(--viz-bullish)' : 'var(--text-soft)'};
`;

export const ErrorWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const ErrorText = styled.span<{ $read: boolean }>`
  ${typographyV2.bodyXs};
  color: ${({ $read }) => ($read ? 'var(--text-soft)' : 'var(--text-warning)')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;

export const AlfredLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  ${borderRadius.rFull};
  background-color: var(--background-default);
`;
